import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FilterProvidersView.
 * @extends JetView
 */
export default class FilterProvidersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields for filtering providers
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Provider Id
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Proveedor Id'),
                            labelPosition: 'top',
                            placeholder: _('Proveedor Id'),
                            invalidMessage: _('Proveedor Id is required'),
                        },
                        {
                            view: 'text', // Input for Provider Name
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            invalidMessage: _('Nombre is required'),
                        },
                        {
                            view: 'combo',
                            name: 'Type',
                            minWidth: 200,
                            id: 'Type',
                            label: _('Tipo'), // Label for type selection
                            labelPosition: 'top',
                            options: [],
                            placeholder: _('Click para seleccionar '),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for Activation Status
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Second left section with additional filters
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for Verification Status
                            name: 'IsVerified',
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text', // Input for Abbreviated Name
                            name: 'Abbreviated',
                            label: _('Abreviado'),
                            labelPosition: 'top',
                            placeholder: _('Abreviado'),
                            invalidMessage: _('Abreviado is required'),
                        },
                        { id: 'grav3', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section layout
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the first left section
                },
            ],
        };

        // Second upper section layout
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 130 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Contains the second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Contains the second upper section
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            minWidth: 200,
                            view: 'button', // Button to add provider
                            value: _('Añadir Proveedor'),
                            hidden: !devConfig.getPermAction('ProvidersAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-ProvidersAdd',
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                this.app.callEvent('addProvider:button', [[]]); // Event to add provider
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to consult providers
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('providers:filter', [
                                    filterdata, // Trigger filter event
                                ]);
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for main filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for main filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Contains the upper section
                                    accordion_section, // Contains the advanced filters section
                                    buttons, // Contains the action buttons
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Main return object for the form view
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Contains the main accordion section
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity elements for small screens
                $$('grav2').hide();
                $$('grav3').hide();
            }
        });

        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'PartnersSubProviders/GetTypeSubProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Error message on AJAX failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text);
                    var optionsTypes = $$('Type').getList();
                    optionsTypes.clearAll(); // Clear existing options
                    optionsTypes.parse(data.data); // Parse and set new options
                    setTimeout(() => {
                        $$('Type').setValue('1'); // Set default value after a short delay
                    }, 10);
                },
            });
    }
}

// FILE DOCUMENTED
